import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const ShoppingFunnel00Table: GenericTableSchemaInterface = {
  id: "shoppingfunnel-00",
  name: "Shopping Funnel 00",
  description: "This table measure conversion rate for when a chat user is shown an inventory carousel.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "START"
    },
    c04: {
      name: "Operator Has Inventory Carousel"
    },
    c05: {
      name: "User Wants Vehicle Storage"
    },
    c06: {
      name: "Show Inventory"
    },
    c07: {
      name: "Unit Selected"
    },
    c08: {
      name: "Phone is Set"
    },
    c09: {
      name: "Phone Collected"
    },
    c10: {
      name: "No Units Available"
    },
    c11: {
      name: "Search Different Store"
    },
    c12: {
      name: "Length",
      variable: VarKey.UnitLength
    },
    c13: {
      name: "Width",
      variable: VarKey.UnitWidth
    },
    c14: {
      name: "Features",
      variable: VarKey.UnitFeatures
    },
    c15: {
      name: "Rate",
      variable: VarKey.UnitRate
    },
    c16: {
      name: "SizeFiltersAtView",
      variable: VarKey.UserFilterSize
    },
    c17: {
      name: "FeatureFiltersAtView",
      variable: VarKey.UserFilterFeatures
    }
  }
};
